import React from "react";
import UlLi, { scrollTo, mountCode, initDeepLinkData, urlChangeHandler} from "js/utilities/sdk-doc-utils";
import { Grid, Row, Col, Table, Label, Glyphicon} from "react-bootstrap";
import { Navigation, Link } from "react-router";
import SDKSidebar from "js/utilities/sdk-sidebar"



export default React.createClass({
  displayName: "photo-id-anti-spoofing-and-anti-tampering",

  getInitialState: function() {
    return {
      scrollToElement: scrollToElement
    };
    var scrollToElement = initDeepLinkData(this.props);
  },

  componentDidMount: function() {
    mountCode(this);
  },

  componentWillMount() {
    window.addEventListener('popstate', this.urlChanged, false)
  },

  urlChanged() {
    urlChangeHandler();
  },

  render: function() {

    return (
      <div>
        <div className="dash">
          <div className="workspace">
            <div className="workspace__container server_integration">

              <section id="Introduction">
                <div className="title">
                  <Glyphicon glyph="list" />
                  <h2 id="photo-id-anti-spoofing-and-anti-tampering-guide">Photo ID Anti-Spoofing</h2>
                  <p>Learn about new ID Scan anti-spoofing algorithms that are used in the Photo ID Match process.</p>
                </div>
                <hr/>
              </section>

              <section>
                <h3 id="overview">Overview</h3>
                <p>FaceTec Device SDKs +8.6 scan Photo IDs to ensure that the faces shown have not been edited and that they are physical documents, not <strong><u>digital spoofs</u></strong>.</p>
                <p>As part of the Onboarding process, high-resolution digital images of the User’s ID Document are taken. These photos are processed on the User’s device; a proprietary, tamper-proof payload is created and encrypted by the Device SDK.  Your App sends the IDScan payload up to your Server, where it is decrypted by the FaceTec Server SDK.  The FaceTec Server SDK verifies that the images contain the entire ID Document, and if they don’t, a retry request is sent to the User, and the IDScan will be flagged if it was captured from a digital screen, rather than being a physical document.</p>
                <hr />
              </section>

              <section>
                <h3 id="onboarding">State-of-the-Art Onboarding</h3>
                <p>FaceTec changes the order of operations of the Onboarding process to increase usability, security, and reduce costs.  By performing the Liveness Check first, the Users move further through the sign-up process before they have to go retrieve a document, and since fraudsters don’t want to put their 3D Face on camera, they never even get the opportunity to show Fake IDs to the system.</p>
                <hr />
              </section>

              <section>
                <h3 id="requirements">Requirements</h3>
                <p>Your App must utilize FaceTec's Photo ID Scan User Interface, which is included in all of the FaceTec Device SDKs and features to perform authenticity and anti-tampering checks.</p>
                <hr />
              </section>

              <section>
                <h3 id="anti-spoofing">Overview of FaceTec’s Anti-Spoofing and Anti-Tamper Checks</h3>
                <p>There are several new behaviors, properties, and checks that FaceTec performs during the ID Scan and Photo ID Match:</p>
                <ul>
                  <li><p>The Photo ID is checked to ensure it is not a <strong><u>digital spoof</u></strong>.  A digital spoof of an ID is an ID presented on a digital screen.</p></li>
                  <li><p>The ID Scan is checked to ensure a Full ID is presented.  The ID may be deemed "full" if the vast majority of the ID is present.  If 4 corners of the ID are in view, the ID <strong>should be</strong> deemed "full".</p></li>
                  <li><p>A Match Level will not be returned if FaceTec assesses that the ID Scan was not a complete ID.</p></li>
                  <li><p><span style={{color:"red"}}><strong><u>Coming Soon</u></strong></span>: The Photo ID is checked to ensure that the face region has not been replaced or tampered with.  This will detect the replacement of the photo ID image in either a digital artifact or a physical ID.</p></li>
                </ul>
                <hr />
              </section>

              <section>
                <h3 id="results">Checking the Photo ID Match Results</h3>
                <p>To perform a Photo ID Match, you must start as shown in our Sample Apps using the FaceTec Session constructor that accepts a <code>ZoomIDScanProcessor</code>.  The <code>ZoomIDScanResult</code> contains the <code>ZoomIDScan</code> object, which must be passed into the FaceTec Server SDK for evaluation.</p>
                <p>On the result object returned by the FaceTec Server SDK, check the <code>ZoomFullIDStatus</code> to check whether FaceTec assessed the user scanned their Full ID.  Note:  The Match Level reported by the Photo ID Match will ALWAYS be zero if the <code>ZoomFullIDStatus</code> is <code>FullIDNotDetected</code> and the <code>ZoomIdScanRejectBehavior</code> in the <code>ZoomInitializeConfig</code> is set to <code>REJECT_IF_NOT_FULL_ID</code>.</p>
                <p>On the result object returned by the FaceTec Server SDK, check the <code>ZoomDigitalSpoofStatus</code> to determine whether the scan was attempted against an ID that is presented on a digital screen.  Note:  The SDKs are configured to ALLOW success and completion of the FaceTec Photo ID Match process even if the scan was determined to be from a digital screen.  Developers can customize this behavior, and can also use the FaceTec Server Dashboard to view/audit these results.</p>
                <hr />
              </section>

              <section>
                <h3 id="dashboard-display">FaceTec Server Dashboard Display</h3>
                <p>These results also appear when viewing the FaceTec Server Dashboard.</p>
                <hr />
              </section>

              <section>
                <h3 id="upcoming-features">Other Notes and Upcoming Features</h3>
                <ul>
                  <li><p>Coming soon: OCR - In a future release, FaceTec will provide OCR functionality.</p></li>
                  <li><p>Coming soon: Barcode scanning and NFC - In a future release, FaceTec will read document barcodes and NFC chips to provide the raw data.  This data will also be correlated to information from the rest of the ID and the 3D FaceMap for additional security and confidence.</p></li>
                </ul>
                <hr />
              </section>

              <SDKSidebar menuType="main" title="Photo ID Anti-Spoofing"/>

            </div>
          </div>
        </div>
      </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/js/components/screens/photo-id-anti-spoofing-and-anti-tampering.jsx